import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findPayList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-pay/v1/channel?` + params,
        method: 'GET'
    })
}

export const addPay = (data) => {
    return request({
        url: `${baseUrl}/joins-pay/v1/channel`,
        method: 'POST',
        data: data
    })
}
export const editPay = (data) => {
    return request({
        url: `${baseUrl}/joins-pay/v1/channel`,
        method: 'PUT',
        data: data
    })
}
export const delPay = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-pay/v1/channel/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const startRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/startRule/${id}`,
        method: 'GET'
    })
}
export const stopRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/stopRule/${id}`,
        method: 'GET'
    })
}